export const hexToPastel = (hex, mode = 'light') => {
  const rgb = hexToRGB(hex);
  if (!rgb) return hex;

  const weight = 0.85;
  const target = mode === 'dark' ? { r: 35, g: 35, b: 39 } : { r: 255, g: 255, b: 255 };

  const pastelRGB = {
    r: Math.round(rgb.r * (1 - weight) + target.r * weight),
    g: Math.round(rgb.g * (1 - weight) + target.g * weight),
    b: Math.round(rgb.b * (1 - weight) + target.b * weight),
  };

  return RGBToHex(pastelRGB);
};

const hexToRGB = hex => {
  if (!hex) return;

  const hexValue = hex.replace(/^#/, '');
  const r = parseInt(hexValue.substring(0, 2), 16);
  const g = parseInt(hexValue.substring(2, 4), 16);
  const b = parseInt(hexValue.substring(4, 6), 16);
  return { r, g, b };
};

const RGBToHex = rgb => {
  if (!rgb) return;
  return '#' + [rgb.r, rgb.g, rgb.b].map(channel => channel.toString(16).padStart(2, '0')).join('');
};
